import { css } from 'twin.macro';
import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Button } from 'react-bootstrap';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { TiTick, TiMinus } from 'react-icons/ti';
//components
import SideBar from '../Layouts/SideBar/SideBar';
import ReactSelectComponent from '../../Admin/users/ReactSelectComponent';
import MessageListener from '../Common/MessageListener';
import EventModal from '../../Admin/Tasks/EventModal';

//redux
import { connect } from 'react-redux';
import {
    getTaskByassignedToId,
    getTaskByChannelId,
    getTaskByChannelIdAndUserId,
    getTaskByMonth,
    postATask,
    editTaskDate,
} from '../../../_redux/actions/ActionTasks';

import Calendar from '../../Admin/Tasks/Calender';
import Task from './Task';
import { EventsStyles } from './styles/EventsContainerStyles';
import { checkPermission } from '../../../_helpers/roles/check-roles';
import {
    DateSorter,
    fetchWrapper,
    getDemandableDateString,
    getTasksOfTheMonth,
    TimeSorter,
    toastWrapper,
} from '../../../_helpers';
import LoadingSpiner from '../../../_elements/LoadingSpiner';
import { UPrimaryButton } from '../../../_elements/Buttons';
import { HiChevronDoubleUp } from 'react-icons/hi';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import NavigationBar from '../../Admin/reusableComponents/NavigationBar';
import EventTypeModal from '../../Admin/Tasks/EventTypeModal';
import CustomTabs from './CustomTabs';
import { FaUsers } from 'react-icons/fa';
import { useMemo } from 'react';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import DateTimePicker from 'react-datetime-picker/dist/DateTimePicker';
import { toast } from 'react-toastify';
import './styles/AddToCalendarTickClose.css';
import { VscLoading } from 'react-icons/vsc';
// import EventPlannerCalendar from '../../Admin/activity/EventPlannerCalendar';

dayjs.extend(isSameOrAfter);

const ChannelDetail = ({ channel }) => {
    return (
        <div>
            {channel ? (
                <div
                    css={css`
                        margin: 0.5rem 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    `}
                >
                    <h1
                        css={css`
                            color: #757575;
                        `}
                    >
                        <b>Channel: {channel.title}</b>
                    </h1>
                    <div>
                        <FaUsers className="icon mr-4" />
                        <b>{channel?.teamData?.name}</b>
                    </div>
                </div>
            ) : (
                <LoadingSpiner size={25} />
            )}
        </div>
    );
};

const EventsContainer = ({
    CurrUser,
    tasks,
    getTaskByassignedToId,
    getTaskByChannelId,
    getTaskByChannelIdAndUserId,
    getTaskByMonth,
    postATask,
    teams,
    editTaskDate,
}) => {
    const { channelId } = useParams();
    const TODAY = dayjs().format('YYYY-MM-DD');
    const [selectedDate, setSelectedDate] = useState(TODAY);
    const [selectedMonthYear, setSelectedMonthYear] = useState(dayjs(TODAY).format('YYYY-MM'));
    // const selectedDayTasks = getTasksOfTheDay(tasks, selectedDate);
    const allTasks = getTasksOfTheMonth([...(tasks?.tasklist || []), ...(tasks?.externalEventList || [])]);
    const [isTickButtonDisabled, setIsTickButtonDisabled] = useState(false);
    const [clickedEvent, setClickedEvent] = useState({});
    const [showEventId, setShowEventId] = useState(false);
    // const [mode, setMode] = useState();
    const [addOrRemoveEvents, setAddOrRemoveEvents] = useState('');

    const [channel, setChannel] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [mobileSidebar, setMobileSidebar] = useState(false);
    const [disableRemoveFromCalendar, setDisableRemoveFromCalendar] = useState(false);
    const currUrl = window.location.href;
    const isAdminPanel = currUrl.includes('tasks');
    const [selectedOption, setSelectedOption] = useState(() => {
        if (isAdminPanel) {
            return {};
        } else {
            return { label: CurrUser.name, value: CurrUser.id };
        }
    });

    const [fetchedTasks, setFetchedTasks] = useState([]);
    const [addToCalendarView, setAddToCalendarView] = useState({});

    const handleDateSelect = (date) => {
        setSelectedDate(dayjs(date).format('YYYY-MM-DD'));
    };

    const handleMonthChange = (yyyyMMFormatDate, isToday) => {
        if (isToday) {
            setSelectedDate(TODAY);
        } else {
            setSelectedDate(yyyyMMFormatDate + '-01');
        }
        setSelectedMonthYear(yyyyMMFormatDate);
        setCurrentPage(1);
    };

    useEffect(() => {
        if (channelId && channel?._id !== channelId) {
            fetchWrapper
                .get(`/chatrooms/${channelId}`)
                .then((res) => setChannel(res))
                .catch((error) => {
                    if (error.name !== 'AbortError') {
                        toastWrapper.error("Couldn't fetch channel info");
                    }
                });
        }
    }, [channelId]);

    useEffect(() => {
        if (CurrUser) {
            let userTeam = CurrUser.teamList.filter((team) => team.team && team.team?.id === channel?.team);
            let userChannel = CurrUser.roomList.filter((room) => room.room && room.room.id === channelId);
            if (CurrUser.role === 'admin') {
                setUserRole('admin');
            } else if (userTeam.length) {
                if (userTeam[0].role === 'owner' || userTeam[0].role === 'teamManager') {
                    setUserRole(userTeam[0].role);
                } else if (userChannel.length) {
                    setUserRole(userChannel[0].role);
                }
            } else if (userChannel.length) {
                setUserRole(userChannel[0].role);
            } else {
                setUserRole(null);
            }
        }
    }, [CurrUser, channel?.team, channelId]);

    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if (!tasks.isLoading) {
            setFetchedTasks([]);
            if (channelId) {
                if (channel?.type === 'public' || checkPermission(userRole, 'channel:byId')) {
                    getTaskByChannelId(channelId, selectedMonthYear, currentPage);
                } else if (CurrUser.id) {
                    getTaskByChannelIdAndUserId(channelId, CurrUser.id, selectedMonthYear, currentPage);
                }
            } else if (selectedOption?.value) {
                getTaskByassignedToId(selectedOption.value, selectedMonthYear, currentPage);
            } else {
                getTaskByMonth(selectedMonthYear, currentPage);
            }
        }
    }, [channel?.type, channelId, CurrUser?.id, userRole, selectedOption.value, selectedMonthYear, currentPage]);

    const viewAllEvents = () => {
        setSelectedOption({});
        setCurrentPage(1);
    };

    const handleSubmitTask = async (task) => {
        let creator = {
            avatar: CurrUser.avatar,
            id: CurrUser.id,
            name: CurrUser.name,
            onlineStatus: CurrUser.onlineStatus,
        };
        let response = await postATask(task, creator, selectedMonthYear);
        return response;
    };

    const [showDemandDate, setShowDemandDate] = useState([]);
    const [demandedDates, setDemandedDates] = useState({});

    const toogleDemandedDate = (task) => {
        const id = task?._id || task?.id;
        setDemandedDates((prev) => ({
            ...prev,
            [task._id]: {
                demandDate:
                    demandedDates[task?._id]?.demandDate ||
                    new Date(task.subChannelTasks?.find(({ user }) => user === CurrUser.id)?.demandDate || Date.now()),
                demandDueDate:
                    demandedDates[task?._id]?.demandDueDate ||
                    new Date(
                        task.subChannelTasks?.find(({ user }) => user === CurrUser.id)?.demandDueDate || Date.now()
                    ),
            },
        }));
        setShowDemandDate((prevState) => {
            if (prevState.includes(id)) {
                return prevState.filter((item) => item !== id);
            } else {
                return [...prevState, id];
            }
        });
    };

    const handleAddToCalendar = async (task) => {
        try {
            setIsTickButtonDisabled(true);
            editTaskDate({
                _id: task?._id,
                demandedDate: demandedDates[task?._id || task?.id],
                mode: 'add-calendar',
                fromPackage: false,
            });
            toogleDemandedDate(task?._id || task?.id);
            setAddToCalendarView(task);
        } catch (err) {
            toast.error(err.message);
        } finally {
            setIsTickButtonDisabled(false);
        }
    };

    const removeAddToCalendar = async (task) => {
        try {
            setDisableRemoveFromCalendar(true);
            editTaskDate({
                _id: task?._id,
                mode: 'remove-calendar',
                fromPackage: false,
            });
        } catch (err) {
            toast.error(err.message);
            console.log(err);
        } finally {
            setDisableRemoveFromCalendar(false);
        }
    };

    const isUserPresentInOnDemandSubchannelTask = (task) =>
        !!task?.subChannelTasks?.find(({ user }) => user === CurrUser?.id);

    const tabData = useMemo(() => {
        const monthStartDay = dayjs(selectedDate).set('date', 1).get('day');
        const monthEndDate = dayjs(selectedDate).endOf('month').get('date');
        const currentDate = dayjs(selectedDate).get('date');

        const rawEndDate = Math.floor((currentDate + monthStartDay - 1) / 7) * 7 + (7 - monthStartDay);
        const weekEndDate = Math.min(monthEndDate, rawEndDate);
        const weekStartDate = Math.max(weekEndDate - 6 + rawEndDate - weekEndDate, 1);
        const todaysEvents =
            allTasks.liveTasks?.filter(
                (task) => dayjs(task.latestDatePointer || task.date).get('date') === currentDate
            ) || [];

        const weeksEvents =
            allTasks.liveTasks?.filter((task) => {
                const taskDate = dayjs(task.latestDatePointer || task.date).get('date');
                return taskDate >= weekStartDate && taskDate <= weekEndDate;
            }) || [];

        return [
            {
                title: selectedDate === TODAY ? 'Todays Events' : `${dayjs(selectedDate).format('MMM DD')} Events`,
                eventKey: 'Todays Event',
                content: (
                    <div className="py-2 task-list">
                        {todaysEvents.length > 0 ? (
                            <Fragment>
                                {todaysEvents?.sort(TimeSorter)?.map((task) => {
                                    return (
                                        <Task
                                            key={task.key || task._id || task.id}
                                            mmddyyyyFormatedDate={dayjs(task.latestDatePointer).format('MM/DD/YYYY')}
                                            task={task}
                                            afterFetch={() => {}}
                                            userRole={userRole}
                                            showDate={false}
                                            isAdminPanel={isAdminPanel}
                                            isTaskFetched={fetchedTasks.includes(task._id || task.id)}
                                            onFetchTask={() => {
                                                setFetchedTasks((prev) => [...prev, task._id || task.id]);
                                            }}
                                            selectedMonthYear={selectedMonthYear}
                                        />
                                    );
                                })}
                            </Fragment>
                        ) : (
                            <div className="noEventMsg">
                                No Events{' '}
                                {selectedDate === TODAY ? 'Today' : `on ${dayjs(selectedDate).format('MMM DD')}`}
                            </div>
                        )}
                    </div>
                ),
                disabled: false,
            },
            {
                eventKey: 'Weekly Events',
                title: `${dayjs(selectedDate).format('MMM')} ${weekStartDate} - ${weekEndDate} Events`,
                content: (
                    <div className="py-2 task-list">
                        {weeksEvents.length > 0 ? (
                            <Fragment>
                                {weeksEvents?.sort(DateSorter)?.map((task) => {
                                    return (
                                        <Task
                                            key={task.key || task._id || task.id}
                                            mmddyyyyFormatedDate={dayjs(task.latestDatePointer).format('MM/DD/YYYY')}
                                            task={task}
                                            afterFetch={() => {}}
                                            userRole={userRole}
                                            showDate={false}
                                            isAdminPanel={isAdminPanel}
                                            isTaskFetched={fetchedTasks.includes(task._id || task.id)}
                                            onFetchTask={() => {
                                                setFetchedTasks((prev) => [...prev, task._id || task.id]);
                                            }}
                                            selectedMonthYear={selectedMonthYear}
                                        />
                                    );
                                })}
                            </Fragment>
                        ) : (
                            <div className="noEventMsg">
                                No Events from {dayjs(selectedDate).format('MMM')} {weekStartDate} to {weekEndDate}
                            </div>
                        )}
                    </div>
                ),
                disabled: false,
            },
            {
                title: `${dayjs(selectedDate).format('MMMM')} Events`,
                eventKey: 'Months Event',
                content: (
                    <div className="py-2 task-list">
                        {allTasks?.liveTasks?.length === 0 ? (
                            <div className="noEventMsg">No Events on {dayjs(selectedDate).format('MMMM')}</div>
                        ) : (
                            allTasks?.liveTasks?.sort(DateSorter).map((task) => (
                                <Task
                                    key={task.key || task._id || task.id}
                                    mmddyyyyFormatedDate={dayjs(task.latestDatePointer).format('MM/DD/YYYY')}
                                    task={task}
                                    userRole={userRole}
                                    showDate={true}
                                    isAdminPanel={isAdminPanel}
                                    isTaskFetched={fetchedTasks.includes(task._id || task.id)}
                                    onFetchTask={() => {
                                        setFetchedTasks((prev) => [...prev, task._id || task.id]);
                                    }}
                                    selectedMonthYear={selectedMonthYear}
                                />
                            ))
                        )}
                    </div>
                ),
                disabled: false,
            },
            {
                title: 'Available Events',
                eventKey: 'onDemand Event',
                content: (
                    <div className="py-2 task-list">
                        {allTasks?.onDemandTasks?.length !== 0 ? (
                            <Fragment>
                                {allTasks?.onDemandTasks?.map((task) => (
                                    <Fragment key={task.key || task._id || task.id}>
                                        <Task
                                            mmddyyyyFormatedDate={
                                                task?.subChannelTasks?.length > 0
                                                    ? (() => {
                                                          const matchingTask = task.subChannelTasks.find(
                                                              ({ user }) => user === CurrUser?.id
                                                          );

                                                          return matchingTask
                                                              ? dayjs(matchingTask?.demandDate).format(
                                                                    'MM/DD/YYYY hh:mm A '
                                                                )
                                                              : getDemandableDateString(task);
                                                      })()
                                                    : getDemandableDateString(task)
                                            }
                                            task={task}
                                            userRole={userRole}
                                            showDate={false}
                                            isAdminPanel={isAdminPanel}
                                            showEventId={showEventId}
                                            setShowEventId={setShowEventId}
                                            addOrRemoveEvents={addOrRemoveEvents}
                                            clickedEvent={clickedEvent}
                                            clickedEventPackage={task?.eventPackage}
                                            isTaskFetched={fetchedTasks.includes(task._id || task.id)}
                                            onFetchTask={() => {
                                                setFetchedTasks((prev) => [...prev, task._id || task.id]);
                                            }}
                                            setClickedEvent={setClickedEvent}
                                            addToCalendarView={addToCalendarView}
                                        />
                                        <div
                                            className="d-flex justify-start align-items-center w-100"
                                            css={css`
                                                position: relative;
                                                bottom: 9px;
                                                display: flex;
                                                // align-items: center;
                                                gap: 5px;
                                                flex-wrap: wrap;
                                            `}
                                        >
                                            {!isUserPresentInOnDemandSubchannelTask(task) ? (
                                                <Fragment>
                                                    {task?.eventPackage ? (
                                                        <Button
                                                            onClick={() => {
                                                                setAddOrRemoveEvents('add');
                                                                setClickedEvent(task?.eventPackage);
                                                                setShowEventId(task?._id || task?.id);
                                                                // setMode(task?.eventMode);
                                                            }}
                                                        >
                                                            Add to Calendar
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            onClick={() => toogleDemandedDate(task)}
                                                            variant={
                                                                showDemandDate.includes(task?._id)
                                                                    ? 'secondary'
                                                                    : 'primary'
                                                            }
                                                            css={css`
                                                                height: 36px;
                                                            `}
                                                        >
                                                            {showDemandDate.includes(task?._id)
                                                                ? 'Cancel'
                                                                : 'Add to Calendar'}
                                                        </Button>
                                                    )}
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    {task?.eventPackage ? (
                                                        <Fragment>
                                                            <Button
                                                                onClick={() => {
                                                                    setAddOrRemoveEvents('remove');
                                                                    setClickedEvent(task?.eventPackage);
                                                                    setShowEventId(task?._id || task?.id);
                                                                    // setMode(task?.eventMode);
                                                                }}
                                                            >
                                                                Remove from Calendar
                                                            </Button>
                                                            <Button
                                                                onClick={() => {
                                                                    setAddOrRemoveEvents('edit');
                                                                    setClickedEvent(task?.eventPackage);
                                                                    setShowEventId(task?._id || task?.id);
                                                                    // setMode(task?.eventMode);
                                                                }}
                                                            >
                                                                Edit Dates
                                                            </Button>
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            <Button
                                                                disabled={disableRemoveFromCalendar}
                                                                onClick={() => removeAddToCalendar(task)}
                                                            >
                                                                Remove from Calendar
                                                            </Button>
                                                            <Button
                                                                onClick={() => toogleDemandedDate(task)}
                                                                variant={
                                                                    showDemandDate.includes(task?._id)
                                                                        ? 'secondary'
                                                                        : 'primary'
                                                                }
                                                                css={css`
                                                                    height: 36px;
                                                                `}
                                                            >
                                                                {showDemandDate.includes(task?._id)
                                                                    ? 'Cancel'
                                                                    : 'Edit Date'}
                                                            </Button>
                                                        </Fragment>
                                                    )}
                                                </Fragment>
                                            )}

                                            {showDemandDate.includes(task?._id) && (
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        gap: 8px;
                                                        marginleft: 12px;
                                                    `}
                                                >
                                                    <DateTimePicker
                                                        onChange={(date) =>
                                                            setDemandedDates((prev) => ({
                                                                ...prev,
                                                                [task._id]: {
                                                                    demandDate: date,
                                                                    demandDueDate:
                                                                        date &&
                                                                        new Date(
                                                                            new Date(date).valueOf() + task.duration
                                                                        ),
                                                                },
                                                            }))
                                                        }
                                                        // ref={register}
                                                        value={
                                                            demandedDates[task?._id]?.demandDate ||
                                                            new Date(
                                                                task.subChannelTasks?.find(
                                                                    ({ user }) => user === CurrUser.id
                                                                )?.demandDate || Date.now()
                                                            )
                                                        }
                                                        format="MM-dd-y hh:mm a"
                                                        disableClock={true}
                                                        calendarType={'US'}
                                                        minDate={
                                                            new Date(
                                                                Math.max(
                                                                    new Date(),
                                                                    new Date(task.latestDatePointer || task.date)
                                                                )
                                                            )
                                                        }
                                                    />
                                                    <span>-</span>
                                                    <DateTimePicker
                                                        onChange={(date) =>
                                                            setDemandedDates((prev) => ({
                                                                ...prev,
                                                                [task._id]: {
                                                                    demandDate: prev[task._id]?.demandDate,
                                                                    demandDueDate: date,
                                                                },
                                                            }))
                                                        }
                                                        // ref={register}
                                                        value={
                                                            demandedDates[task?._id]?.demandDueDate ||
                                                            new Date(
                                                                task.subChannelTasks?.find(
                                                                    ({ user }) => user === CurrUser.id
                                                                )?.demandDueDate || Date.now()
                                                            )
                                                        }
                                                        format="MM-dd-y hh:mm a"
                                                        disableClock={true}
                                                        calendarType={'US'}
                                                        minDate={
                                                            new Date(
                                                                Math.max(
                                                                    new Date(),
                                                                    new Date(task.latestDatePointer || task.date)
                                                                )
                                                            )
                                                        }
                                                        disabled
                                                    />
                                                    <button
                                                        disabled={isTickButtonDisabled}
                                                        onClick={() => handleAddToCalendar(task)}
                                                        className={`
															add-to-calendar-tick-button 
															${isTickButtonDisabled ? ' disabled ' : ''}`}
                                                    >
                                                        <TiTick size={20} className="tick-icon" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Fragment>
                                ))}
                            </Fragment>
                        ) : (
                            <div className="noEventMsg">No Available Events</div>
                        )}
                    </div>
                ),
                disabled: false,
            },
        ];
    }, [allTasks, channel, isAdminPanel, selectedDate, userRole]);

    return (
        <div className="m-0 p-0">
            <MessageListener />
            {!isAdminPanel && (
                <SwitchTransition>
                    <CSSTransition key={mobileSidebar} timeout={500} classNames={'sidebar-ani-'}>
                        <SideBar mobileSidebar={mobileSidebar} setMobileSidebar={setMobileSidebar} />
                    </CSSTransition>
                </SwitchTransition>
            )}
            <EventsStyles
                css={css`
                    ${isAdminPanel && `margin-left:0px;`}
                `}
            >
                <div className="w-100 d-flex justify-content-between align-items-center">
                    {!isAdminPanel ? (
                        <h1
                            css={css`
                                color: #757575;
                                font-weight: bold;
                                margin-left: 10px;
                            `}
                        >
                            {channelId && 'Channel '}
                            Events
                        </h1>
                    ) : (
                        <div
                            css={css`
                                margin-left: 10px;
                            `}
                        >
                            <NavigationBar mainTabName="Events" />
                        </div>
                    )}
                    <div className="d-flex">
                        {isAdminPanel && <EventTypeModal />}
                        {checkPermission(userRole, 'create:event') ? (
                            <EventModal
                                channel={channel}
                                handleSubmitTask={handleSubmitTask}
                                teamIds={userRole === 'admin' ? teams.map((t) => t._id) : [channel?.teamData?.id]}
                            />
                        ) : null}
                    </div>
                </div>
                <div className="eventWrapper">
                    <div className="calendar">
                        {channelId ? (
                            <div>
                                <ChannelDetail channel={channel} />
                            </div>
                        ) : (
                            CurrUser.role === 'admin' && (
                                <div className="mt-4 d-flex">
                                    <div className="w-50 mx-3">
                                        <ReactSelectComponent
                                            selectedOption={selectedOption}
                                            setSelectedOption={(user) => {
                                                setSelectedOption(user);
                                                setCurrentPage(1);
                                            }}
                                            placeholder="Filter by User"
                                            isDisabled={tasks.isLoading}
                                        />
                                    </div>

                                    <Button
                                        variant="primary"
                                        onClick={() => viewAllEvents()}
                                        disabled={tasks.isLoading}
                                    >
                                        View All Events
                                    </Button>
                                </div>
                            )
                        )}

                        <Calendar
                            tasks={[...(allTasks?.liveTasks || []), ...(tasks?.externalEventList || [])]}
                            dateSelected={selectedDate}
                            handleDateSelect={handleDateSelect}
                            handleMonthChange={handleMonthChange}
                        />
                        <div
                            className="py-3 px-3 lead "
                            css={css`
                                font-size: 20px;
                            `}
                        >
                            Note: Click on date above to view events for that date. Also check out month or weekly tabs
                            on your right to view events for that month or week.
                        </div>
                    </div>
                    <div
                        css={css`
                            display: flex;
                            flex-direction: column;
                            gap: 12px;
                            align-items: end;
                        `}
                    >
                        <CustomTabs data={tabData} />
                        {/* <EventPlannerCalendar events={Object.values(allTasks).flat()}/> */}
                        {tasks.tasklist.length < tasks.totalTasks && (
                            <Button
                                disabled={tasks.isLoading}
                                onClick={() => {
                                    if (!tasks.isLoading && tasks.tasklist.length < tasks.totalTasks) {
                                        setCurrentPage((prev) => prev + 1);
                                    }
                                }}
                            >
                                {tasks.isLoading && <VscLoading className="spin mr-2" />}Load More Events
                            </Button>
                        )}
                    </div>
                </div>
            </EventsStyles>
            {!isAdminPanel && (
                <div className="sidebar-toggle position-fixed" onClick={() => setMobileSidebar(!mobileSidebar)}>
                    {!mobileSidebar && <HiChevronDoubleUp />}
                </div>
            )}
        </div>
    );
};
const mapStateToProps = (state) => ({
    CurrUser: state.user.user,
    tasks: state.tasks,
    teams: state.teams.teams,
});

export default connect(mapStateToProps, {
    getTaskByassignedToId,
    getTaskByMonth,
    getTaskByChannelId,
    getTaskByChannelIdAndUserId,
    postATask,
    editTaskDate,
})(EventsContainer);
